import { Suspense, useEffect, useState } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import useLogoutOnClose from "../helper/logoutHook";
import PrivateRoute from "./private-route";
import { privateRoutes } from "./route-list";
import NotFound from "../pages/not-found";
import Loader from "../components/common/loader";
import PreloadImages from "../components/common/preloadImages";
import {
  LoginSignUpStaticImages,
  SidebarStaticIcons,
  usePreloadSelectors,
} from "../helper/utils";

function DefaultRoutes() {
  const bypassAnnouncement = ["/game-section"];
  // useLogoutOnClose();
  const { casinoProviders, banners } = usePreloadSelectors();
  const { data } = useSelector((state) => state.config);
  const [headerDetails, setHeaderDetails] = useState({
    show: false,
    message: "",
  });

  useEffect(() => {
    console.log(199, data?.themeColor, "#007bff");

    if (data?.themeColor) {
      const primaryColor = data?.themeColor || "#007bff";
      document.documentElement.style.setProperty(
        "--color-purple",
        primaryColor
      );
      document.documentElement.style.setProperty("--bg-info", primaryColor);
      document.documentElement.style.setProperty(
        "--secondary-accent",
        primaryColor
      );
      document.documentElement.style.setProperty(
        "--sidebar-color",
        primaryColor
      );
    }
  }, [data]);

  const configData = useSelector((state) => state.config.data);

  useEffect(() => {
    if (!configData?.headerSettings) return;

    let hasAnnouncement = false;
    let hasShowFlag = false;
    const updates = {};

    configData.headerSettings.forEach((setting) => {
      if (setting.api_key === "header_announcement") {
        updates.message = setting.value;
        hasAnnouncement = true;
      }
      if (setting.api_key === "show_header_announcement") {
        updates.show = setting.value.toLowerCase() === "true";
        hasShowFlag = true;
      }
    });

    if (hasAnnouncement && hasShowFlag) {
      setHeaderDetails((prev) => ({ ...prev, ...updates }));
    } else {
      setHeaderDetails({ show: false, message: "" });
    }
  }, [configData]);

  return (
    <section className="page h-90">
      {headerDetails.show &&
        !bypassAnnouncement.includes(window.location.pathname) && (
          <div className="announcement-bar overflow-hidden whitespace-nowrap">
            <div className="announcement-text inline-block">
              {headerDetails.message}
            </div>
          </div>
        )}
      <PreloadImages
        staticImages={[...LoginSignUpStaticImages, ...SidebarStaticIcons]}
        dynamicImageLists={[
          { list: casinoProviders, key: "image_url" },
          { list: banners, key: "image" },
        ]}
        onComplete={() => {
          console.log("🚀 All images preloaded");
        }}
      />
      <Suspense fallback={<Loader />}>
        <Router>
          <Routes>
            <Route path="*" element={<NotFound />} />

            {privateRoutes.map((itm, index) => (
              <Route
                key={index}
                path={itm.path}
                exact
                isAuthProtected={itm.isAuthProtected}
                element={
                  <PrivateRoute
                    name={itm.path}
                    path={itm.path}
                    component={itm?.layout}
                    element={itm?.layout}
                    isAuthProtected={itm.isAuthProtected}
                  />
                }
              />
            ))}
          </Routes>
        </Router>
      </Suspense>
    </section>
  );
}

export default DefaultRoutes;
